import { filter } from 'rxjs/operators';
import { AnyAction } from 'redux';

/**
 * Safe version of ofType that handles undefined actions
 * This prevents the "Cannot read properties of undefined (reading 'type')" error
 */
export function safeOfType(...keys: string[]) {
  return filter((action: AnyAction) => {
    // Safety check: ensure action exists and has a type property
    if (!action || typeof action !== 'object' || !action.type) {
      console.warn('safeOfType: Received invalid action:', action);
      return false;
    }
    
    return keys.some(key => action.type === key);
  });
}